var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypesNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_34",
    "data-name": "Groupe 34",
    transform: "translate(-1635 -1203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    transform: "translate(1635 1203)",
    fill: "none",
    stroke: "#c3c3c3",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 58.5,
    height: 58.5,
    rx: 7.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-sign-to-navigate",
    transform: "translate(1658.985 1242.176) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M9.679,11.034a1.352,1.352,0,0,1-.958-.4L.4,2.314A1.356,1.356,0,0,1,2.314.4L9.679,7.762,17.043.4A1.356,1.356,0,0,1,18.96,2.314l-8.323,8.323A1.352,1.352,0,0,1,9.679,11.034Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypesNext);
export default __webpack_public_path__ + "static/media/types-next.d24c338100f253858c1164098f3e5c8a.svg";
export { ForwardRef as ReactComponent };